import _slugify from "slugify";

export function slugify(inputString: string): string {
  const s = _slugify(inputString, {
    lower: true,
    remove: /[*+~.()'"!:@#$%&,/;=?[\]{}|\\<>]/g,
  });

  return s;
}
